/*
 * Copyright (c) 2023 Bolmate B.V.
 */

import {ResponseData, showDialog, useEvent} from '@dvrd/dvr-controls';
import React, {useContext, useEffect, useState} from 'react';
import {useNavigate} from 'react-router';
import FailedPayment from '../../models/failedPaymentModel';
import {PaymentFailureStatus} from '../../util/interfaces';
import {createErrorMessage, userHasSubscription} from '../../util/utils';
import {AppContext} from '../misc/appContext';
import TrialEnd from './trialEnd';

export default function TrialEndController() {
    const context = useContext(AppContext);
    const [active, setActive] = useState(false);
    const [failedPayment, setFailedPayment] = useState<FailedPayment | null>(null);
    const [loading, setLoading] = useState(false);
    const [buttonDisabled, setButtonDisabled] = useState(false);
    const navigate = useNavigate();
    useEvent('onTrialEnd', onActivate);

    function onActivate() {
        setActive(true);
        setButtonDisabled(false);
    }

    function onProceed() {
        if (failedPayment) {
            if (failedPayment.paymentUrl) window.open(failedPayment.paymentUrl, '_blank');
            else onGenerateNew();
        } else {
            navigate('/instellingen/abonnement');
            setActive(false);
        }
    }

    function onGenerateNew() {
        if (!failedPayment) return;
        setLoading(true);
        failedPayment.generateInvoice({
            callback: (failedPayment: FailedPayment, success: boolean, data: ResponseData) => {
                setLoading(false);
                if (success) {
                    setButtonDisabled(true);
                    setFailedPayment(failedPayment);
                    window.open(failedPayment.paymentUrl, '_blank');
                } else
                    showDialog(
                        createErrorMessage(data.message ?? 'Het genereren van een nieuwe factuur is niet gelukt.'),
                        'Factuur mislukt');
            }
        });
    }

    useEffect(() => {
        setFailedPayment(context.userContext.user?.subscription?.failedPayment ?? null);
    }, [context.userContext.user?.subscription?.failedPayment]);

    useEffect(() => {
        const failedPayment = context.userContext.user?.subscription?.failedPayment;
        const hasOpenPayment = !!failedPayment && failedPayment.status !== PaymentFailureStatus.CLOSED;
        const active = !userHasSubscription(
            context.userContext.user) || hasOpenPayment;
        setActive(active);
    }, [context.userContext.user, context.userContext.user?.subscription?.failedPayment]);

    return (
        <TrialEnd onProceed={onProceed} active={active} failedPayment={failedPayment} loading={loading}
                  buttonDisabled={buttonDisabled}/>
    );
}